import React, { ErrorInfo, ReactNode } from 'react';
import ErrorPage from './components/common/ErrorPage';
import errorResponses from './errorResponses';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage error={errorResponses.errorBoundaryInApp} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
